import React, { HTMLAttributes, PureComponent, ReactElement } from 'react';
import './FilterGrid.css';

interface FilterGridProps {
    direction: 'horizontal' | 'vertical';

    topLeft?: ReactElement;
    top?: ReactElement;
    topRight?: ReactElement;
    left?: ReactElement;
    center?: ReactElement;
    right?: ReactElement;
    bottomLeft?: ReactElement;
    bottomRight?: ReactElement;
    bottom?: ReactElement;
}

/**
 * The FilterGrid is used to display horizontal/vertical filter hexagonal buttons.
 * It is displayed in a grid of 48 columns and 40 rows (or the contrary for vertical mode) and each cell has an height/width of 0.15em.
 * The grid is built to guaranty that the central hexagon always has a controlled size (20cols/18rows => 3em x 2.7em).
 * In horizontal model, the grid size is 8.7em x 4.5em
 */
export class FilterGrid extends PureComponent<FilterGridProps & HTMLAttributes<HTMLDivElement>> {
    renderGridItem = (
        position:
            | 'top-left'
            | 'top'
            | 'top-right'
            | 'bottom-left'
            | 'left'
            | 'center'
            | 'right'
            | 'bottom-right'
            | 'bottom',
        component: ReactElement,
    ) => {
        if (!component) return undefined;
        let contentClassName;
        if (position === 'top' || position === 'bottom') {
            contentClassName = 'content';
        } else {
            contentClassName = 'content hexagon';
        }
        return (
            <div className={'filter-grid-item ' + position}>
                {React.cloneElement(component, { className: contentClassName })}
            </div>
        );
    };
    render() {
        const {
            direction,
            topLeft,
            top,
            topRight,
            left,
            center,
            right,
            bottomLeft,
            bottomRight,
            bottom,
            ...otherProps
        } = this.props;
        return (
            <div className="filter-grid-wrapper" {...otherProps}>
                <div className={'filter-grid ' + this.props.direction}>
                    {this.renderGridItem('top-left', this.props.topLeft)}
                    {this.renderGridItem('top', this.props.top)}
                    {this.renderGridItem('top-right', this.props.topRight)}
                    {this.renderGridItem('left', this.props.left)}
                    {this.renderGridItem('center', this.props.center)}
                    {this.renderGridItem('right', this.props.right)}
                    {this.renderGridItem('bottom-left', this.props.bottomLeft)}
                    {this.renderGridItem('bottom-right', this.props.bottomRight)}
                    {this.renderGridItem('bottom', this.props.bottom)}
                </div>
            </div>
        );
    }
}
